import { FormContextType, RegistryWidgetsType, RJSFSchema, StrictRJSFSchema } from '@rjsf/utils';

import { CheckboxWidget } from './CheckboxWidget';
import { CountryWidget } from './CountryWidget';
import { DateWidget } from './DateWidget';
import { EmailWidget } from './EmailWidget';
import { FieldNameWidget } from './FieldNameWidget';
import { FileWidget } from './FileWidget';
import { MaskedWidget } from './MaskedWidget';
import { SelectWidget } from './SelectWidget';
import { StatusWidget } from './StatusWidget';
import { SubDirectionWidget } from './SubDirectionWidget';
import { SubSubDirectionWidget } from './SubSubDirectionWidget';
import { SwitchWidget } from './SwitchWidget';
import { TextareaWidget } from './TextareaWidget';
import { TextWidget } from './TextWidget';
import { URLWidget } from './URLWidget';
import { NationalTargetsWidget } from './NationalTargetsWidget';

export function generateWidgets<
	T = unknown,
	S extends StrictRJSFSchema = RJSFSchema,
	F extends FormContextType = unknown
>(): RegistryWidgetsType<T, S, F> {
	return {
		URLWidget,
		CheckboxWidget,
		EmailWidget,
		SelectWidget,
		TextWidget,
		TextareaWidget,
		SwitchWidget,
		DateWidget,
		status: StatusWidget,
		file: FileWidget,
		masked: MaskedWidget,
		fieldName: FieldNameWidget,
		subDirection: SubDirectionWidget,
		nationalProjects: NationalTargetsWidget('NationalProjectsBaseValues'),
		nationalTargets: NationalTargetsWidget('NationalTargetsBaseValues'),
		subSubDirection: SubSubDirectionWidget,
		country: CountryWidget,
	};
}

export default generateWidgets();
